import Icon from '../../../Icon/Icon';
import { Tooltip, type TooltipProps } from '../../../Tooltip/Tooltip';
import { StyledColumnHeader, StyledHeaderText } from '../../styles/columnHeaders';

export interface DataGridColumnHeaderWithToolTipProps
  extends Omit<TooltipProps, 'title' | 'children'> {
  id: string;
  headerName: string;
  description: string;
}

export const DataGridColumnHeaderWithToolTip = (props: DataGridColumnHeaderWithToolTipProps) => {
  const { id, headerName, description, placement = 'top', ...rest } = props;

  const tooltipId = `${id}-header-tooltip-${headerName.replace(/\s+/g, '').toLowerCase()}`;

  return (
    <StyledColumnHeader>
      <StyledHeaderText>{headerName}</StyledHeaderText>
      <Tooltip {...rest} id={tooltipId} title={description} placement={placement} arrow>
        <Icon id={`${tooltipId}-icon`} height={18} width={18} icon="info" />
      </Tooltip>
    </StyledColumnHeader>
  );
};
